import { Auth, API } from 'aws-amplify';
import { apiGateway, manageGateway } from './config';

const ApiHeaders = async () => {
  const session = await Auth.currentSession();

  return {
    ...apiGateway.apiInit.headers,
    Authorization: `Bearer ${session.getAccessToken().getJwtToken()}`
  };
};

const createApiInit = async (options, gateway = apiGateway) => ({
  ...gateway.apiInit,
  ...options,
  headers: await ApiHeaders()
});

const ApiGet = async (path, queryStringParameters = undefined) => {
  const init = await createApiInit(queryStringParameters ? { queryStringParameters } : undefined);
  return API.get(apiGateway.apiName, apiGateway.apiPath + path, init);
};

const ApiGetNoWait = async path => {
  const init = await createApiInit();
  return API.get(apiGateway.apiName, apiGateway.apiPath + path, init);
};

const ApiGetArray = async getArray => {
  return Promise.all(
    getArray.map(async path => API.get(apiGateway.apiName, apiGateway.apiPath + path, await createApiInit()))
  );
};

const ApiCall = async item => {
  const path = apiGateway.apiPath + item.resource;

  if (item.method === 'POST') {
    const init = await createApiInit({ body: item.body });
    return API.post(apiGateway.apiName, path, init);
  }

  const init = await createApiInit();
  return API.get(apiGateway.apiName, path, init);
};

const ApiCallArray = async callArray => {
  const calls = Array.isArray(callArray) ? callArray : [callArray];
  return Promise.all(calls.map(ApiCall));
};

const ApiPost = async (path, body) => {
  const init = await createApiInit({ body });
  return API.post(apiGateway.apiName, apiGateway.apiPath + path, init);
};

const ManageApiGet = async (path, queryStringParameters = undefined) => {
  const init = await createApiInit(queryStringParameters ? { queryStringParameters } : undefined, manageGateway);
  return API.get(manageGateway.apiName, manageGateway.apiPath + path, init);
};

const ManageApiPost = async (path, body) => {
  const init = await createApiInit({ body }, manageGateway);
  return API.post(manageGateway.apiName, manageGateway.apiPath + path, init);
};

export { ApiGet, ApiGetNoWait, ApiGetArray, ApiCallArray, ApiHeaders, ApiPost, ManageApiGet, ManageApiPost };
